// extracted by css-extract-rspack-plugin
export default {"FormControl":"get-project-items-block-module__FormControl__VDooCXl","Box":"get-project-items-block-module__Box__S4pjzuh"};